var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getNpsRatingByChasis } from "../../../api/url";
import { getByIdAPI, getListAPI } from "../../../redux/crudSlice";
import { store } from "../../../store/store";
import { customerDetailsGet, InstallBaseListURL, serviceHistoryUrl, vehicleHistoryKeys } from "./entity";
var dispatch = store.dispatch;
export var InstallBaseListAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload, _a, key, _b, url, _c, request, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? vehicleHistoryKeys.InstallBaseListKey : _a, _b = params.url, url = _b === void 0 ? InstallBaseListURL : _b, _c = params.request, request = _c === void 0 ? {} : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload = res.payload) === null || _res$payload === void 0 ? void 0 : _res$payload.value];
        }
    });
}); };
export var getCustomerDetailsAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload2, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? vehicleHistoryKeys.CustomerDetailsKey : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? customerDetailsGet(request.id) : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload2 = res.payload) === null || _res$payload2 === void 0 ? void 0 : _res$payload2.value];
        }
    });
}); };
export var serviceHistoryAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload3, _a, key, _b, request, _c, url, res;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _a = params.key, key = _a === void 0 ? vehicleHistoryKeys.SeviceHistoryKey : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? serviceHistoryUrl : _c;
                return [4 /*yield*/, dispatch(getByIdAPI({
                        key: key,
                        url: url,
                        request: request
                    }))];
            case 1:
                res = _d.sent();
                return [2 /*return*/, res === null || res === void 0 || (_res$payload3 = res.payload) === null || _res$payload3 === void 0 ? void 0 : _res$payload3.value];
        }
    });
}); };
export var fetchNpsByChassis = function (chassisNo) { return __awaiter(void 0, void 0, void 0, function () {
    var _res$payload$value$da, _res$payload4, res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, dispatch(getListAPI({
                    key: '',
                    url: getNpsRatingByChasis,
                    request: {
                        Chassis: chassisNo
                    }
                }))];
            case 1:
                res = _a.sent();
                return [2 /*return*/, (_res$payload$value$da = res === null || res === void 0 || (_res$payload4 = res.payload) === null || _res$payload4 === void 0 || (_res$payload4 = _res$payload4.value) === null || _res$payload4 === void 0 ? void 0 : _res$payload4.data) !== null && _res$payload$value$da !== void 0 ? _res$payload$value$da : []];
        }
    });
}); };
